import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactImage from '../../shared/components/ContactImage';
import ListSelect from '../../shared/components/ListSelect';
import { useUserAccess } from '../../shared/hooks/useUserAccess';
import { fetchExtensionDetails } from '../../shared/store/thunks';
import { StoreDispatch, StoreState } from '../store';
import * as styles from '../styles/form.module.scss';
import UserLevelError from './UserLevelError';

const ExtensionSelect: React.FC = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const logoSrc = useSelector(
    (state: StoreState) => state.branding.partnerLogoSrc,
  );
  const { availableExtensions, hasWebRTCEnabledExtensions } = useUserAccess();

  const availablePhones = availableExtensions.map((p) => ({
    title: p.name,
    text: p.shortNumber,
    value: p.id,
    icon: (
      <ContactImage email={p.email} id={p.id} type={p.type} status={false} />
    ),
  }));

  if (!hasWebRTCEnabledExtensions) {
    return (
      <UserLevelError
        title="It looks like you don't have any regular extensions that you can use."
        description='Please either add a regular extension you have access to, or
                    log in with a user that does have access to a regular
                    extension.'
      />
    );
  }

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <img alt='Logo' className={styles.logo} src={logoSrc} />
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_small}>Select your extension</h2>
            <div className={styles.form_body}>
              <ListSelect
                items={availablePhones}
                itemSelected={(value) => {
                  dispatch(fetchExtensionDetails(value));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtensionSelect;
